import { Flex } from "antd";
import "./styles.css";

export const TwoColumnBox = ({ leftElement, rightElement }) => {
  return (
    <Flex
      justify="space-between"
      align="flex-start"
      wrap="wrap"
      className="two-column-box"
    >
      <div className="two-column-box--element">{leftElement}</div>
      <div className="two-column-box--bar"></div>
      <div className="two-column-box--element">{rightElement}</div>
    </Flex>
  );
};
